<template>
    <div class="flex w-full p-4 justify-start items-center gap-2 text-gray-500">
        <div class="flex-col w-full ">
            <div v-if="noData" class="flex w-full items-start gap-2">
                <div>
                    <InformationCircleIcon class="h-[50px] w-[50px]"/>
                </div>

                <div>
                    <div>
                        <p class="font-medium text-amber-800 truncate text-xs">
                        {{ title || $t(`${'noData'}`) }}              
                        </p>
                    </div>

                    {{ text || $t(`${'noData_description'}`) }}
                </div>
            </div>

            <div v-else class="flex-col w-full">
                <!-- -------------------------- -->
                <!-- TICKETS -->
                <!-- -------------------------- -->        
                <div v-if="type=='tickets'">
                    <div class="flex justify-between w-full gap-2">
                    <div class="flex  flex-col justify-end items-center">
                        <div class="ghost h-4 w-[15px] rounded mb-1"></div>
                        <div class="ghost h-4 w-[15px] rounded mb-3"></div>
                    </div>
                    <div class="w-full">
                        <div class="ghost h-2 sm:w-[200px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[250px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[180px] rounded mb-3"></div>
                        <div class="ghost h-2 sm:w-[200px] rounded mb-3"></div>
                        <div class="flex gap-4">
                        <div class="ghost h-2 w-[100px] rounded mb-3"></div>
                        <div class="ghost h-2 w-[100px] rounded mb-3"></div>
                        </div>
                    </div>
                    <div class="flex items-center pr-10">
                        <div class=" ghost rounded-full h-10 w-10"></div>
                    </div>
                    </div>
        
                    <div class="ghost h-0.5 sm:w-full rounded mb-3 mt-3"></div>
        
                    <div class="flex justify-between w-full gap-2 mt-4">
                    <div class="flex  flex-col justify-end items-center">
                        <div class="ghost h-4 w-[15px] rounded mb-1"></div>
                        <div class="ghost h-4 w-[15px] rounded mb-1"></div>
                        <div class="ghost h-4 w-[15px] rounded mb-3 "></div>
                    </div>
                    <div class="w-full">
                        <div class="ghost h-2 sm:w-[200px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[250px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[180px] rounded mb-3"></div>
                        <div class="ghost h-2 sm:w-[200px] rounded mb-3"></div>
                        <div class="flex gap-4">
                        <div class="ghost h-2 w-[100px] rounded mb-3"></div>
                        <div class="ghost h-2 w-[100px] rounded mb-3"></div>
                        </div>
                    </div>
                    <div class="flex items-center pr-10">
                        <div class=" ghost rounded-full h-10 w-10"></div>
                    </div>
                    </div>
                </div>
    
                <!-- -------------------------- -->
                <!-- USER CARDS -->
                <!-- -------------------------- -->
    
                <div v-if="type=='user_cards'">
                    <ul role="list" class="mt-4 grid gap-4" :class="this.userCardsClass">
                        <li class="card" v-for="(_, index) in Array(4)" :key="index">
                            <div class="flex w-full gap-2">
                                <div class="flex items-start pl-2">
                                    <div class=" ghost rounded-full h-10 w-10"></div>
                                </div>
                                <div class="w-full">              
                                    <div class="ghost h-4 w-1/2 rounded mb-3"></div>
                                    <div class="ghost h-2 w-1/3 rounded mb-3"></div>
                                    <div class="ghost h-2 w-1/4 rounded mb-3"></div>
                                </div>
                            </div>
                        </li>            
                    </ul>
                </div>
    
                <!-- -------------------------- -->
                <!-- Line -->
                <!-- -------------------------- -->
                <div v-if="type=='line' || !type">
                    <div class="flex w-full items-center">
                    <div class="w-full">
                        <div class="ghost h-2 sm:w-[100px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[180px] rounded mb-3"></div>
                        <div class="ghost h-2 sm:w-[140px] rounded mb-3"></div>
                    </div>
                    <div class="flex gap-2 pr-5">
                        <div class=" ghost rounded-full h-6 w-6"></div>
                        <div class=" ghost rounded-full h-6 w-6"></div>
                    </div>
                    </div>
        
        
                    <div class="ghost h-0.5 sm:w-full rounded mb-3 mt-3"></div>
        
        
                    <div class="flex w-full items-center mt-4">
                    <div class="w-full">
                        <div class="ghost h-2 sm:w-[80px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[210px] rounded mb-3"></div>
                        <div class="ghost h-2 sm:w-[100px] rounded mb-3"></div>
                    </div>
                    <div class="flex gap-2 pr-5">
                        
                    </div>
                    </div>     
        
        
                    <div class="ghost h-0.5 sm:w-full rounded mb-3 mt-3"></div>
                    
                    <div class="flex w-full items-center mt-4">
                    <div class="w-full">
                        <div class="ghost h-2 sm:w-[110px] rounded mb-3"></div>
                        <div class="ghost h-4 sm:w-[150px] rounded mb-3"></div>
                        <div class="ghost h-2 sm:w-[170px] rounded mb-3"></div>
                    </div>
                    <div class="flex gap-2 pr-5">
                        <div class=" ghost rounded-full h-6 w-6"></div>
                    </div>
                    </div>            
                </div>

                <!-- -------------------------- -->
                <!-- Messengers -->
                <!-- -------------------------- -->
                <div v-if="type=='messengers'">
                    <div class="px-4 flex w-full items-center gap-8">
                        <div class="ghost h-5 w-6 rounded"></div>

                        <div class="ghost rounded-full h-10 w-11"></div>

                        <div class="w-full">
                            <div class="ghost h-4 w-[180px] rounded mb-3"></div>
                            <div class="ghost h-3 w-[100px] rounded"></div>
                        </div>
                    </div>
        
                    <div class="ghost h-0.5 sm:w-full rounded my-5"></div>

                    <div class="px-4 flex w-full items-center gap-8">
                        <div class="ghost h-5 w-6 rounded"></div>

                        <div class="ghost rounded-full h-10 w-11"></div>

                        <div class="w-full">
                            <div class="ghost h-4 w-[180px] rounded mb-3"></div>
                            <div class="ghost h-3 w-[100px] rounded"></div>
                        </div>
                    </div>

                    <div class="ghost h-0.5 sm:w-full rounded my-5"></div>

                    <div class="px-4 flex w-full items-center gap-8">
                        <div class="ghost h-5 w-6 rounded"></div>

                        <div class="ghost rounded-full h-10 w-11"></div>

                        <div class="w-full">
                            <div class="ghost h-4 w-[180px] rounded mb-3"></div>
                            <div class="ghost h-3 w-[100px] rounded"></div>
                        </div>
                    </div>
                </div>


                <!-- -------------------------- -->
                <!-- Chats -->
                <!-- -------------------------- -->
                <div v-if="type=='chats'" class="-m-4">
                    <div class="flex flex-col w-full items-center gap-2 ">
                        <div class="ghost h-[58px] w-full rounded"></div>
                        <div class="ghost h-[58px] w-full rounded"></div>
                        <div class="ghost h-[58px] w-full rounded"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
  
<script>
  
import { InformationCircleIcon } from '@heroicons/vue/24/outline'

import ViewSizeMixin from '_app/resources/mixins/ViewSizeMixin';
  
export default {
        name: 'NoData',

        components: {
            InformationCircleIcon
        },

        mixins: [
            ViewSizeMixin
        ],

        props: {
            type: {
                type: String,
                default: 'line'
            },
            title: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
        },
    
        data() {
            return {
                noData: false,
            }
        },
    
        created() {
            setTimeout(() => {
                this.noData = true;
            }, 2000);
        },

        computed: {
            userCardsClass() {
                if (this.isXl) {
                    return 'grid-cols-4';
                } if (this.isMd) {
                    return 'grid-cols-2';
                }
                
                return 'grid-cols-1';
            },
        },
  }
</script>